import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.375 11.415a.75.75 0 0 0 .375-.65v-6.75a.75.75 0 0 0-1-.702A9.756 9.756 0 0 0 2.413 14.28a.75.75 0 0 0 1.113.514zM8.25 5.152v5.18l-4.489 2.59c-.011-.14-.011-.283-.011-.422a8.26 8.26 0 0 1 4.5-7.348M12 2.75a.75.75 0 0 0-.75.75v8.608l-7.388 4.304a.75.75 0 0 0-.27 1.031A9.75 9.75 0 1 0 12 2.75m0 18a8.3 8.3 0 0 1-6.702-3.439l7.08-4.125a.75.75 0 0 0 .375-.649V4.284A8.25 8.25 0 0 1 12 20.75"
    }, null, -1)
  ])))
}
export default { render: render }